import { NgModule } from "@angular/core";
import { BillingContactRoutingModule } from "@onsip/web/features/accountSettings/billingContact/billing-contact-routing.module";
import { BillingContactComponent } from "@onsip/web/features/accountSettings/billingContact/billing-contact.component";
import { TranslateModule } from "@ngx-translate/core";
import { MatButtonModule } from "@angular/material/button";
import { ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { OnsipFormsModule } from "@onsip/web/features/shared/components/forms/onsip-forms.module";
import { PipesModule } from "@onsip/web/features/shared/pipes/pipes.module";
import { MatSelectModule } from "@angular/material/select";
import { LoadingContainerComponent } from "../../shared/components/loadingContainer/loading-container.component";

@NgModule({
  imports: [
    CommonModule,
    BillingContactRoutingModule,
    TranslateModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    OnsipFormsModule,
    PipesModule,
    MatSelectModule,
    LoadingContainerComponent
  ],
  declarations: [BillingContactComponent]
})
export class BillingContactModule {}
